"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Header = _antd.Layout.Header,
  Content = _antd.Layout.Content,
  Sider = _antd.Layout.Sider;
var items1 = ['1', '2', '3'].map(function (key) {
  return {
    key: key,
    label: "nav ".concat(key)
  };
});
var items2 = [_icons.UserOutlined, _icons.LaptopOutlined, _icons.NotificationOutlined].map(function (icon, index) {
  var key = String(index + 1);
  return {
    key: "sub".concat(key),
    icon: /*#__PURE__*/_react.default.createElement(icon),
    label: "subnav ".concat(key),
    children: new Array(4).fill(null).map(function (_, j) {
      var subKey = index * 4 + j + 1;
      return {
        key: subKey,
        label: "option".concat(subKey)
      };
    })
  };
});
var App = function App() {
  var _theme$useToken = _antd.theme.useToken(),
    _theme$useToken$token = _theme$useToken.token,
    colorBgContainer = _theme$useToken$token.colorBgContainer,
    borderRadiusLG = _theme$useToken$token.borderRadiusLG;
  return /*#__PURE__*/_react.default.createElement(_antd.Layout, null, /*#__PURE__*/_react.default.createElement(Header, {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "demo-logo"
  }), /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    theme: "dark",
    mode: "horizontal",
    defaultSelectedKeys: ['2'],
    items: items1,
    style: {
      flex: 1,
      minWidth: 0
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Layout, null, /*#__PURE__*/_react.default.createElement(Sider, {
    width: 200,
    style: {
      background: colorBgContainer
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    mode: "inline",
    defaultSelectedKeys: ['1'],
    defaultOpenKeys: ['sub1'],
    style: {
      height: '100%',
      borderRight: 0
    },
    items: items2
  })), /*#__PURE__*/_react.default.createElement(_antd.Layout, {
    style: {
      padding: '0 24px 24px'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb, {
    style: {
      margin: '16px 0'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, null, "Home"), /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, null, "List"), /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, null, "App")), /*#__PURE__*/_react.default.createElement(Content, {
    style: {
      padding: 24,
      margin: 0,
      minHeight: 280,
      background: colorBgContainer,
      borderRadius: borderRadiusLG
    }
  }, "Content"))));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(App, null),
  key: 'top-side-2'
};
var _default = exports.default = componentDemo;